import React, {useContext, useEffect, useState} from "react";
import LOGO from "../img/LOGO.png";
import lg from "../img/lg.png"
import flowers from "../img/flowers.png"
import crest from "../img/crest.png"
import ochnislogow from "../img/ochnislogow.png"
import LocaleSwitch from "../components/LocaleSwitch";
import {LanguageContext} from "../App";
import {Link} from "react-router-dom";
import {isMobile} from "react-device-detect";
import {Helmet} from "react-helmet";

import { Gallery, Item } from 'react-photoswipe-gallery'
import 'photoswipe/dist/photoswipe.css'


import PhotoAlbum from "react-photo-album";

import Map, {Layer, Marker, NavigationControl, ScaleControl, Source} from 'react-map-gl';
import { createClient } from '@supabase/supabase-js'
import og360 from "../img/og360.jpg";


const TOKEN = 'pk.eyJ1IjoidGltb2ZlamFuZHJvcG92IiwiYSI6ImNsMG1zN3pyNTE1eWczY25zd2ExcHNkd3EifQ.bAxtoJwQXLx_e2ZWpYa1fQ';
const supabase = createClient('https://sxipkzxjsnnaybxthrxf.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN4aXBrenhqc25uYXlieHRocnhmIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzY3NDEwMzgsImV4cCI6MTk5MjMxNzAzOH0.ToB8TL555TnCAjl_jmNdhY86bmTvttL5K1aRAlZUOI8')

const YearPhotoPage = () => {
    const {language} = useContext(LanguageContext)

    const [ images, setImages ] = useState([])
    //36.209016, 25.517773
    //81.288226, -163.014719

    // const [viewport, setViewport] = useState({
    //     latitude: 64.17,
    //     longitude: 105.13,
    //     zoom: 2,
    //     maxZoom: 4,
    //     minZoom: 1,
    //     bearing: 0,
    //     pitch: 0
    // });

    //
    const [ points, setPoints ] = useState({})

    async function fetchPhotos () {
        const { data, error } = await supabase
            .from('images')
            .select('*')
            .order('created_at',  { ascending: false })
        // console.log(data)
        return data
    }


    useEffect(() => {
        fetchPhotos().then((data)=>{
            setImages(data)
        })


    },[])

    const [isMobileMenu, setIsMobileMenu] = useState(false)

    const mmenuShow = () => {
        console.log('mclick')
        setIsMobileMenu(true)
        // console.log(content.fields.text_md)
    }
    const mmenuHide = () => {
        setIsMobileMenu(false)
    }

    const photos = images.map((photo) => ({
        src: photo.cdn_url,
        width: photo.crop ? photo.crop_width : photo.width,
        height: photo.crop ? photo.crop_height : photo.height,
        city: photo.city,
        address: photo.address,
        source: photo.source
        // images: breakpoints.map((breakpoint) => {
        //     const height = Math.round((photo.height / photo.width) * breakpoint);
        //     return {
        //         src: unsplashLink(photo.id, breakpoint, height),
        //         width: breakpoint,
        //         height,
        //     };
        // }),
    }));


    const PhotoRenderer = ({ photo, wrapperStyle, renderDefaultPhoto, restWrapperProps }) => {
        const { width, height,  src, uuid, city, source, address} = photo;
        // console.log(photo)
        const caption = address ?
                    `
                    <div class="bg-black/50 p-4">
                        <h3 class="font-bold">${city}</h3>
                        <p class="italic">${address}</p>
                        <a href='${source}'>🔗 источник</a>
                    </div>
                    `
                   :
                     `
                    <div class="bg-black/50 p-4">
                        <h3 class="font-bold">${city}</h3>
                        <a href='${source}'>🔗 источник</a>
                    </div>
                    `


        return (
            <div
                key={uuid}
                style={{
                    // width: style.width,
                    // padding: style.padding,
                    // marginBottom: style.marginBottom,
                    ...wrapperStyle
                }}
                {...restWrapperProps}
                className='relative pb-1'
            >
                <Item
                    // content={<h1 className='text-white'>Hi!</h1>}
                    caption={caption}
                    // alt='asdafeef'
                    original={src}
                    thumbnail={src}
                    width={width}
                    height={height}
                    key={uuid}
                >
                    {({ref, open}) => (
                        <div ref={ref}>
                            <img src={src}
                                 className='cursor-pointer rounded'
                                 onClick={open}
                                 width={width}
                                 height={height}
                            />
                            {/*<img*/}
                            {/*    quality={50}*/}
                            {/*    // key = {id}*/}
                            {/*    loading={"lazy"}*/}
                            {/*    width={width}*/}
                            {/*    height={height}*/}
                            {/*    placeholder={"blur"}*/}
                            {/*    blurDataURL={'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDVPuMlKfGrFErmCt6hCuECLbbhekJF-GCtAJvPIZpHX5upTT-hABFlp8qZY8rkgaZ0DE&usqp=CAU'}*/}

                            {/*    src={photo_public_url}*/}
                            {/*/>*/}
                        </div>

                    )}
                </Item>
                <div className='text-neutral-100 text-center pt-1'>
                    {city}
                </div>
            </div>
            // <div style={{position: "relative", ...wrapperStyle}}>
            //     {renderDefaultPhoto({wrapped: true})}
            //     {photo.title && (
            //         <div
            //             style={{
            //                 position: "absolute",
            //                 overflow: "hidden",
            //                 backgroundColor: "rgba(255 255 255 / .6)",
            //                 inset: "auto 0 0 0",
            //                 padding: 8,
            //             }}
            //         >
            //             {photo.city}
            //         </div>
            //     )}
            // </div>
        )

    }

    return (
        <div className=' bg-black'>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Россия скорбит</title>
                <meta name="description" content="24.02.2023 - День памяти и скорби"/>

                {/*Facebook Meta Tags*/}
                <meta property="og:url" content="https://remap-ru.com/360/photos"/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content="Россия скорбит"/>
                <meta property="og:description" content="24.02.2023 - День памяти и скорби"/>
                <meta property="og:image" content={og360}/>

                <meta name="twitter:card" content="summary_large_image"/>
                <meta property="twitter:domain" content="remap-ru.com"/>
                <meta property="twitter:url" content="https://remap-ru.com/360/photos"/>
                <meta name="twitter:title" content="Россия скорбит"/>
                <meta name="twitter:description" content="24.02.2023 - День памяти и скорби"/>
                <meta name="twitter:image" content={og360}/>

            </Helmet>

            <main className='bg-black'>
                <div className='py-20 bg-gradient-to-b from-neutral-900/80 via-neutral-900/50 '>
                    <div className='flex max-w-7xl mx-auto items-center px-3'>
                        <div className='w-auto'>
                            <img src={lg} width={80} alt=""/>
                        </div>
                        <div className='pl-6'>
                            <h2 className='text-2xl font-bold text-neutral-400'>24.02.2023</h2>
                            <h1 className='text-4xl font-bold text-neutral-100 pt-1'>РОССИЯ СКОРБИТ</h1>
                            <h1 className='text-2xl font-bold text-neutral-400 pt-1'>День памяти и скорби*</h1>
                        </div>
                    </div>
                    {/*<img src={low} alt=""/>*/}


                </div>

                <div className='py-12'>
                    <div className='max-w-7xl mx-auto px-8'>
                        <div className='text-2xl font-bold text-neutral-300 text-center'>
                            ФОТОГАЛЕРЕЯ
                        </div>
                        <div className='pt-12'>
                            <Gallery withCaption>
                                <PhotoAlbum
                                    layout="masonry"
                                    columns={(containerWidth) => {
                                        if (containerWidth < 400) return 1;
                                        if (containerWidth < 600) return 2;
                                        if (containerWidth < 900) return 3;
                                        return 4;
                                    }}
                                    photos={photos}
                                    renderPhoto={PhotoRenderer}
                                />
                            </Gallery>

                        </div>
                    </div>
                </div>

                <div className='bg-neutral-800/60 mt-10 pt-4 pb-8'>
                    <div className='max-w-7xl mx-auto px-12 pt-4 text-neutral-400'>
                        <div className="flex flex-col items-center justify-center">
                            <div className="text-center">Сайт разработан
                                при поддержке движения
                            </div>
                            <a target="_blank" rel="noreferrer" href="https://t.me/wakeup_russia"><img className="pt-4"
                                                                                                       width="160"
                                                                                                       height="46"
                                                                                                       src={ochnislogow}
                                                                                                       alt="Движение ОЧНИСЬ"/></a></div>
                    </div>
                </div>

            </main>
        </div>
    )
}

export default YearPhotoPage